import { Typography } from "@mui/material";

const Settings = () => {
    return (<>
        <Typography variant='h3'>Settings </Typography>
    </>)
}

export default Settings;